import { LogOut } from 'lucide-react';

import { Panel, PanelHeader } from '@/components/ui/Panel';
import { Button } from '@/components/ui/Button';
import { useAuthStore } from '@/store/auth';

/**
 * Signing out used to be reachable only from the mobile navigation sheet. The
 * bottom tab bar deliberately carries destinations and nothing else, so the
 * action moved here — the same place a trader already goes to end a session on
 * another device.
 */
export function SignOutSection() {
  const signOut = useAuthStore((state) => state.signOut);
  const email = useAuthStore((state) => state.trader?.email);

  return (
    <Panel padding="none">
      <PanelHeader
        title="Выход из аккаунта"
        description="Платежи в работе не отменяются — они продолжают идти по своему сроку."
      />

      <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-4">
        <div className="min-w-0">
          <p className="eyebrow">Вы вошли как</p>
          <p className="num mt-1 break-all text-base text-fg">{email ?? '—'}</p>
        </div>

        <Button
          variant="danger"
          icon={<LogOut size={15} strokeWidth={1.5} aria-hidden="true" />}
          onClick={signOut}
        >
          Выйти
        </Button>
      </div>
    </Panel>
  );
}
